import { c as _c } from "react/compiler-runtime";
import { keyCombinationsMap } from "@loaders/key-combinations";
import { runtimeConfig } from "@src/runtime-config";
import { RuntimeUtils, EmailUtils } from "@stellar/utils";
import { useAppSelector } from "@store/store-helper";
import { currentUserSelector } from "@store/user/user-selector";
import { useCallback, useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Component that listens to key events to trigger certain actions.
 */
export function KeyBindingsLoader(t0) {
  const $ = _c(12);
  const {
    children
  } = t0;
  const navigate = useNavigate();
  const location = useLocation();
  const currentUser = useAppSelector(currentUserSelector);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = RuntimeUtils.isProductionEnvironment(runtimeConfig.appEnv);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const isProduction = t1;
  let t2;
  if ($[1] !== location.search || $[2] !== navigate) {
    t2 = updates => {
      const searchParams = new URLSearchParams(location.search);
      for (const [key, value] of Object.entries(updates)) {
        searchParams.set(key, value);
      }
      navigate({
        search: searchParams.toString()
      });
    };
    $[1] = location.search;
    $[2] = navigate;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const setQueryParams = t2;
  let t3;
  if ($[4] !== currentUser?.email) {
    t3 = event => {
      const key_0 = event.code;
      const combinationKey = event.altKey ? `Alt+${key_0}` : key_0;
      const combination = keyCombinationsMap.get(combinationKey);
      if (isProduction && combination?.isOnlyForInternalUsersInProd && !EmailUtils.isInternalUser(currentUser?.email ?? "")) {
        return;
      }
      if (combination?.shouldSkipProd && isProduction) {
        return;
      }
      if (combination?.hasAltKey && !event.altKey) {
        return;
      }
      return combination;
    };
    $[4] = currentUser?.email;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const matchKeyCombination = t3;
  let t4;
  let t5;
  if ($[6] !== matchKeyCombination || $[7] !== setQueryParams) {
    t4 = () => {
      const handleKeydown = function handleKeydown(event_0) {
        if (!event_0.altKey) {
          return;
        }
        const combination_0 = matchKeyCombination(event_0);
        if (combination_0) {
          const updates_0 = {};
          combination_0.action((key_1, value_0) => {
            updates_0[key_1] = value_0;
          });
          setQueryParams(updates_0);
        }
      };
      window.addEventListener("keydown", handleKeydown);
      return () => {
        window.removeEventListener("keydown", handleKeydown);
      };
    };
    t5 = [matchKeyCombination, setQueryParams];
    $[6] = matchKeyCombination;
    $[7] = setQueryParams;
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  useEffect(t4, t5);
  let t6;
  if ($[10] !== children) {
    t6 = <>{children}</>;
    $[10] = children;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}